import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import ExtraInfo from '@sendsprint/ui-react/dist/components/ExtraInfo';
import FormField from '@sendsprint/ui-react/dist/components/Form/formInput';
import FormFieldTextarea from '@sendsprint/ui-react/dist/components/Form/formTextarea';
import FormFieldWithExternalLabel from '@src/components/form/FormFieldWithExternalLabel';
import FormFieldSwitch from '@src/components/form/FormFieldSwitch';
import React, { useEffect } from 'react';
import TargetCurrencyField from '../targetCurrencyField';
import { UseRecurrentPaymentLinkFormResponse } from '../../../hooks/useRecurrentPaymentLinkForm';
import VeriffModal from '@src/components/veriffModal';
import IntervalDropdown from '../intervalDropdown';
import { useFormikContext } from 'formik';

interface Props {
  paymentLinkResponse: UseRecurrentPaymentLinkFormResponse;
}

const PaymentLinkFormContent = ({ paymentLinkResponse }: Props) => {
  const { isLoading, buttonLabel, shouldDisableForm, handleVeriffModalClose, showVeriffModal } =
    paymentLinkResponse;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values, setFieldValue } = useFormikContext<any>();

  const intervalValue = values.interval;
  const isDisabled = !intervalValue || intervalValue?.toString() === '0';

  useEffect(() => {
    if (intervalValue === 0) {
      setFieldValue('intervalCount', 0);
    }
  }, [intervalValue]);

  return (
    <>
      <Box className="ss-bg-white ss-space-y-3 ss-p-4 ss-rounded-lg ss-mb-5">
        <p className="ss-text-neutral-400 ss-text-sm">
          Enter the details to generate a link. Links are securely sent.
        </p>
        {shouldDisableForm && (
          <ExtraInfo
            extraInfo="Payment link currently disabled. To update this payment link, you need to enable it."
            variant="warning"
          />
        )}
      </Box>
      <Box className="ss-bg-white ss-space-y-3 ss-p-4 ss-rounded-lg ss-mb-5">
        <FormFieldWithExternalLabel label="Link name">
          <FormField name="linkName" label="Link name" />
        </FormFieldWithExternalLabel>
        <TargetCurrencyField />
        <FormFieldWithExternalLabel label="Amount">
          <FormField
            name="amount"
            label="Amount"
            type="number"
            extraInfo="To allow customers enter desired amount, leave the box empty"
          />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="Description">
          <FormFieldTextarea name="description" label="Description" />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="Interval">
          <IntervalDropdown />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="When do you want this transfer to stop?">
          <FormField
            name="intervalCount"
            disabled={isDisabled}
            label="Number of count"
            type="number"
            extraInfo="Leave empty to charge customer indefinitely"
          />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="Redirect URL after payment">
          <FormField name="redirectUrl" label="Enter URL" />
        </FormFieldWithExternalLabel>
        <FormFieldSwitch
          name="customerCanCancelSubscription"
          label="Allow Customer cancel this subscription"
          labelDirection="left"
        />
      </Box>
      <Box>
        <Button
          showSpinner={isLoading}
          disabled={isLoading || shouldDisableForm}
          type="submit"
          isBlock
          label={buttonLabel}
        />
      </Box>
      <VeriffModal state={showVeriffModal} handleClick={handleVeriffModalClose} />
    </>
  );
};

export default PaymentLinkFormContent;
